import call from "../../service/http";
import constants from "./DashboardConstants";

export default {
  namespaced: true,
  state: {
    delegates: {
      data: [],
      currentCursor: null,
      nextCursor: null,
      total: 0,
    },
    delegate: {},
    attendee: {},
    report: "",
    request_stack: [],
    loading: false,
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
    PERSIST_ATTENDANCE: (state, payload) => {
      state.delegates.forEach((del) => {
        if (del.no === payload.delegateNo) del.attendance.push(payload);
      });
    },
    PERSIST_REQUEST_STACK: (state, payload) => {
      state.request_stack.push(payload);
    },
    PERSIST_DELEGATE: (state, payload) => {
      switch (payload.type) {
        case "update":
          state.delegates.forEach((del) => {
            if (del.no === payload.no) {
              del = payload.delegate;
            }
          });
          break;
        case "add":
          state.delegates.push(payload.delegate);
          break;
        default:
          break;
      }
    },
  },
  getters: {
    dashboardGetters: (state) => (val) => state[val],
  },
  actions: {
    getDelegates: ({ commit }, data = {}) => {
      commit("MUTATE", { state: "loading", data: true });
      call("get", constants.DELEGATES(data))
        .then((res) => {
          commit("MUTATE", { state: "delegates", data: res.data.data });
          commit("MUTATE", { state: "loading", data: false });
        })
        .catch((err) => {
          commit("MUTATE", { state: "loading", data: false });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    getDelegate: ({ commit }, payload) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("get", constants.GET_DELEGATE(payload))
        .then((res) => {
          commit("Loader/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "delegate",
            data: res.data.data.shift(),
          });
        })
        .catch((err) => {
          commit("Loader/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    searchDelegate: ({ commit }, payload) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("get", constants.SEARCH_DELEGATE(payload))
        .then((res) => {
          commit("Loader/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "delegate",
            data: res.data.data.shift(),
          });

          Event.$emit("scanDelegateFingerprint");
        })
        .catch((err) => {
          commit("Loader/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    saveDelegate: ({ commit, dispatch }, payload) => {
      commit("Loader/SET_DIALOG_LOADING", true, { root: true });
      call("post", constants.SAVE_DELEGATE, payload)
        .then((res) => {
          const delegate = res.data.data.shift();
          commit("MUTATE", {
            state: "delegate",
            data: delegate,
          });
          Event.$emit(payload.type, delegate);

          dispatch("getDelegates");

          commit("Loader/SET_DIALOG_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Delegate Saved Successfully");
          Event.$emit("reloadTemplateScripts");
        })
        .catch((err) => {
          commit("Loader/SET_DIALOG_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    updateDelegate: ({ commit, dispatch }, payload) => {
      commit("Loader/SET_DIALOG_LOADING", true, { root: true });
      call("post", constants.UPDATE_DELEGATE, payload)
        .then((res) => {
          commit("Loader/SET_DIALOG_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Updated Successfully");
          const delegate = res.data.data.shift();
          Event.$emit(payload.type, delegate);
          commit("MUTATE", {
            state: "delegate",
            data: delegate,
          });

          dispatch("getDelegates");
        })
        .catch((err) => {
          console.log(err);
          commit("Loader/SET_DIALOG_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    deleteDelegate: ({ commit }, payload) => {
      commit("Loader/SET_DIALOG_LOADING", true, { root: true });
      call("post", constants.DELETE_DELEGATE(payload))
        .then(() => {
          commit("Loader/SET_DIALOG_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Deleted Successfully");
          Event.$emit(payload.type);
        })
        .catch((err) => {
          commit("Loader/SET_DIALOG_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    submitAttendance: ({ commit, dispatch }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.submitAttendance, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.data);
          dispatch("getDelegates");
          commit("Loader/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    getReport: ({ commit }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("get", constants.getReport(data))
        .then((res) => {
          commit("MUTATE", { state: "report", data: res.data.data.shift() });
          commit("Loader/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    setFingerprint: ({ commit }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.REGISTER_FINGERPRINT, data)
        .then((res) => {
          commit("Loader/SET_LOADING", false, { root: true });
          const delegate = res.data.data.shift();
          commit("MUTATE", {
            state: "delegate",
            data: delegate,
          });

          Event.$emit("reloadTemplateScripts");
          Event.$emit("ApiSuccess", "Fingerprint registered successfully");
        })
        .catch((err) => {
          Event.$emit("reloadTemplateScripts");
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    verifyDelegateFingerprint: ({ commit }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.VERIFY_DELEGATE_FINGERPRINT, data)
        .then((res) => {
          commit("Loader/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Delegate checked in successfully");
          commit("MUTATE", {
            state: "attendee",
            data: res.data.data,
          });
          Event.$emit("payAttendee");
        })
        .catch((err) => {
          Event.$emit("scanDelegateFingerprint");
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    manualCheckin: ({ commit }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.MANUAL_CHECKIN, data)
        .then((res) => {
          commit("Loader/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Checked in successfully");
          commit("MUTATE", {
            state: "attendee",
            data: res.data.data,
          });
          Event.$emit("payAttendee");
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    syncAttendance: ({ commit }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.SYNC_ATTENDANCE, data)
        .then(() => {
          Event.$emit("ApiSuccess", "Attendance Synced successfully");
          commit("Loader/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    editAttendeePay: ({ commit, dispatch }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.editAttendeePay, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          console.log(res[0]);
          dispatch("getDelegate", { no: data.delegateNo });
          Event.$emit("stopEditing");
          commit("Loader/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    addAttendeePay: ({ commit, dispatch }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.addAttendeePay, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          dispatch("getDelegate", { no: data.attendeePays[0].delegateNo });
          Event.$emit("paymentSuccessful");
          commit("Loader/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
    syncDelegates: ({ commit }, data) => {
      commit("Loader/SET_LOADING", true, { root: true });
      call("post", constants.syncDelegates, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Loader/SET_LOADING", false, { root: true });
        });
    },
  },
};
